import { useState } from 'react'

interface HTMLMediaElementWithSinkId extends HTMLAudioElement {
  setSinkId(deviceId: string): Promise<void>
}

export const usePlaySound = () => {
  const [isSoundPlaying, setIsSoundPlaying] = useState(false)

  const sounds = {
    TEST_SOUND:
      'https://res.cloudinary.com/hellojoy/video/upload/v1746151153/sounds/test-audio-chime.mp3',
    NEW_PARTICIPANT:
      'https://res.cloudinary.com/hellojoy/video/upload/v1747111676/sounds/waiting_room_chime.mp3'
  }

  const playSound = (source: string, deviceId: string) => {
    // Create audio instance on demand (better for mobile)
    const audio = new Audio(source) as HTMLMediaElementWithSinkId

    audio.onended = () => {
      setIsSoundPlaying(false)
    }

    setIsSoundPlaying(true)

    // Try to set device if supported
    if (typeof audio?.setSinkId === 'function') {
      audio
        .setSinkId(deviceId)
        .then(() => audio.play())
        .catch((err: any) => {
          console.error('Error setting sinkId:', err)
          // Fallback to default playback if setSinkId fails
          audio.play().catch(err => {
            console.error('Error playing audio from selected device:', err)
            setIsSoundPlaying(false)
          })
        })
    } else {
      // Play directly if setSinkId not supported
      audio.play().catch(err => {
        console.error('Error playing audio directly:', err)
        setIsSoundPlaying(false)
      })
    }
  }

  return {
    playSound,
    isSoundPlaying,
    sounds
  }
}
